var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonVegItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 116"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "white",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M5.63478 3.79394C6.01968 3.12728 6.98193 3.12728 7.36683 3.79395L9.27718 7.10277C9.66208 7.76944 9.18095 8.60277 8.41115 8.60277H4.59045C3.82065 8.60277 3.33953 7.76944 3.72443 7.10277L5.63478 3.79394Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVegItem);
export default __webpack_public_path__ + "static/media/NonVegItem.3ffa9ae7275cff365efb03db213153e6.svg";
export { ForwardRef as ReactComponent };